import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/app/reservation/')({
  beforeLoad: () => {
    throw redirect({
      to: '/app/cycle'
    });
  }
});